@if (theme) {
  <div #careerCenter class="{{ theme?.root }}" [style]="theme?.bgImage">
    <div class="container {{ theme?.container }}">
      @if (careerCenterTitle) {
        <div
          class="p-v-spacing pb-4 pt-v-spacing wysiwyg hidden"
          [innerHTML]="careerCenterTitle"
        ></div>
      }
      <div class="flex flex-col lg:flex-row lg:flex-row-reverse lg:mb-v-spacing" [class.lg:mr-v-spacing]="theme?.container.length === 0">
        <div
          class="flex flex-col mx-0 bg-gray-200 p-v-spacing rounded-ace-mode shadow-card mb-v-spacing lg:items-start lg:bg-transparent lg:pt-0 lg:w-sidebar lg:min-w-sidebar lg:shadow-none lg:rounded-none"
          >
          <div class="px-0 flex w-full lg:bg-gray-200 lg:pt-v-spacing lg:px-v-spacing pb-2 lg:rounded-t-ace-mode lg:ml-v-spacing">
            <p class="mb-2 md:mb-0 font-bold filter-title">{{ filterTitle }}</p>
          </div>
          <div
            class="flex flex-col px-0 align-items-center w-full lg:flex-row lg:bg-gray-200 sm:px-v-spacing lg:pb-v-spacing lg:rounded-b-ace-mode lg:ml-v-spacing"
            >
            <select
              class="select-filter dropdown-native mr-v-spacing lg:mr-0 text-base font-light appearance-none w-full whitespace-nowrap text-left cursor-pointer select-none rounded-md leading-6 h-full"
              (change)="onCategoryFilterChange($event.target.value)"
              [(ngModel)]="selectedCategoryFilter"
              aria-label="Filter articles by category"
              >
              <option value="">
                <h2 class="filter-default-label">{{ filterDefaultLabel }}</h2>
              </option>
              @for (category of categoryList; track category) {
                <option [value]="category">
                  <h2>{{ category }}</h2>
                </option>
              }
            </select>
          </div>
          @if (careerCenterContent) {
            <div
              class="py-v-spacing sm:px-v-spacing lg:pt-0 wysiwyg hidden lg:block"
              [class.mt-v-spacing]="!careerCenterTitle"
              [innerHTML]="careerCenterContent"
            ></div>
          }
        </div>
        <div class="w-full grid grid-cols-1 sm:grid-cols-2 sm:gap-x-6 lg:w-auto" [ngClass]="{'sm:px-v-spacing': theme?.container.length === 0}">
          @if (pages[activeIndex] && pages[activeIndex].length > 0) {
            @for (card of pages[activeIndex]; track card) {
              <career-center-article-card
                [data]="card"
                class="card my-v-spacing sm:mt-0"
                >
              </career-center-article-card>
            }
          }
        </div>
      </div>
      @if (pages.length > 1) {
        <nav role="pagination" class="w-full py-v-spacing px-0 mt-v-spacing text-center">
          <ul class="flex justify-center">
            <li class="page-item cursor-pointer" [ngClass]="{ hidden: activeIndex === 0 }">
              <fa-icon
                class="mr-2 fa-1x page-link"
                (click)="goToPreviousPage(); scroll(careerCenter)"
                [icon]="faArrowLeft"
              ></fa-icon>
            </li>
            <li
              class="page-item cursor-pointer"
          [ngClass]="{
            hidden: pages.length < 4 || (pages.length >= 4 && activeIndex < 2),
            'sm:hidden': pages.length < 4 || (pages.length >= 4 && activeIndex < 3)
          }"
              >
              <fa-icon class="fa-1x page-link" (click)="skip('back'); scroll(careerCenter)" [icon]="faEllipsisH"></fa-icon>
            </li>
            @for (page of pages; track page; let i = $index) {
              <li
                class="page-item page-number"
          [ngClass]="{
            'paging-end': i === deskPageIndex + 3,
            'mobile-end': i === mobilePageIndex + 2,
            'pre-page': i < deskPageIndex && deskPageIndex !== 0,
            'mobile-start': i === deskPageIndex - 1 && deskPageIndex !== 0
          }"
                >
                <a
                  class="button page-link cursor-pointer"
                  [ngClass]="{ active: i === activeIndex }"
                  [href]="getPageUrl(i)"
                  (click)="changePage(i); scroll(careerCenter); $event.preventDefault()"
                  >
                  {{ i + 1 }}
                </a>
              </li>
            }
            <li
              class="page-item cursor-pointer"
          [ngClass]="{
            hidden: pages.length < 4 || (pages.length >= 4 && activeIndex > pages.length - 3),
            'sm:hidden': pages.length < 4 || (pages.length >= 4 && activeIndex >= pages.length - 4)
          }"
              >
              <fa-icon
                class="fa-1x page-link"
                (click)="skip('forward'); scroll(careerCenter)"
                [icon]="faEllipsisH"
              ></fa-icon>
            </li>
            <li class="page-item cursor-pointer" [ngClass]="{ hidden: activeIndex === pages.length - 1 }">
              <fa-icon
                class="fa-1x page-link"
                (click)="goToNextPage(); scroll(careerCenter)"
                [icon]="faArrowRight"
              ></fa-icon>
            </li>
          </ul>
        </nav>
      }
      <hr class="md:hidden my-v-spacing" />
      @if (careerCenterContent) {
        <div
          class="py-v-spacing lg:px-v-spacing wysiwyg block lg:hidden"
          [innerHTML]="careerCenterContent"
        ></div>
      }
    </div>
  </div>
}
